import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import './ConfigureSongs.scss';
import SongCard from '../../Components/SongCard/SongCard';
import FuntoneButton from '../../Components/FuntoneButton/FuntoneButton';
import AddContact from '../../Components/AddContact/AddContact';
import {
  setSelectedSong,
  setIsAssignToContactFlow,
  setIsGalleryMode,
  setPopUp,
  PopUpEnum,
  saveToHistory,
} from '../../FuntoneSlice';
import {useScreenNavigation} from '../../Utils/ScreenNavigationUtils';
import chevronDown from './images/chevron-down.svg';
import plusIcon from './images/plus.svg';
const ConfigureSongs = (props) => {
  const dispatch = useDispatch();
  const {navigateToSongSettings, navigateToSongs} = useScreenNavigation();
  const subscriberGallery = useSelector((state) => state.FuntoneSlice.subscriberGallery);
  const [expandedSongId, setExpandedSongId] = useState(null);

  useEffect(() => {
    dispatch(saveToHistory('configuresongs'));
  }, [dispatch]);

  console.log(props);
  const songsWithContacts = subscriberGallery.filter((song) => {
    if (!song.profiles) return false;
    const profilesArray = Array.isArray(song.profiles.profile)
      ? song.profiles.profile
      : song.profiles.profile
      ? [song.profiles.profile]
      : [];
    return profilesArray.length > 0;
  });

  const {songsConfigurationTitle, configureAnotherSongButtonText} = props.contentData || {};
  const toggleExpand = (songId) => {
    setExpandedSongId((prev) => (prev === songId ? null : songId));
  };

  const handleAddContacts = (song) => {
    dispatch(setSelectedSong(song));
    dispatch(setIsAssignToContactFlow(true));
    navigateToSongSettings();
  };

  const handleAddAnotherSong = () => {
    dispatch(setIsAssignToContactFlow(true));
    navigateToSongs();
  };

  const handleRemoveContact = (song, contact) => {
    console.log('Removing contact:', contact, 'from song:', song);
    // Set the song as selected and show the remove contact popup
    dispatch(setSelectedSong(song));
    dispatch(
      setPopUp({
        type: PopUpEnum.REMOVE_CONTACT,
        data: contact.id,
      }),
    );
  };

  const getContacts = (song) => {
    if (!song.profiles) return [];
    const profilesArray = Array.isArray(song.profiles.profile)
      ? song.profiles.profile
      : song.profiles.profile
      ? [song.profiles.profile]
      : [];
    return profilesArray;
  };

  return (
    <div className='configure-songs-page'>
      <div className='top-content'>
        <div className='title'>
          <span>{songsConfigurationTitle?.value}</span>
        </div>
        <FuntoneButton variant='secondary' text={configureAnotherSongButtonText?.value} onClick={handleAddAnotherSong} icon={plusIcon} />
      </div>
      <div className='songs-list'>
        {songsWithContacts.length === 0 ? (
          <div className='empty-state'>
            <p>אין שירים עם אנשי קשר מוגדרים</p>
          </div>
        ) : (
          songsWithContacts.map((song) => {
            const songId = song.productId || song.id;
            const isExpanded = expandedSongId === songId;
            const contacts = getContacts(song);

            return (
              <div key={songId} className='song-card-container'>
                <SongCard 
                  song={song} 
                  showMenu={false} 
                  headerTitle='' 
                  onClick={() => toggleExpand(songId)}
                  expandButton={
                    <button 
                      className={`expand-button ${isExpanded ? 'expanded' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleExpand(songId);
                      }}
                    >
                      <Image src={chevronDown} alt='expand' />
                    </button>
                  }
                />
                {isExpanded && (
                  <div className='contacts-section'>
                    <div className='contacts-list'>
                      {
                      contacts.map((profile, index) => (
                        <AddContact
                          key={profile.id || index}
                          value={profile.cli?.callerCli || ''}
                          isDeleteMode={true}
                          onClear={() => handleRemoveContact(song, profile)}
                        />
                      ))}
                    </div>
                    <div className='add-contacts-button'>
                      <FuntoneButton
                        variant='text'
                        text='הוספת אנשי קשר'
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAddContacts(song);
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ConfigureSongs;
